import React, { useEffect, useState } from 'react'
import { ReactComponent as IconTimes } from "assets/images/icons/project-icons/times.svg"
import useInlinePageRouter from 'components/__new/general/useInlinePageRouter';
import Maybe from 'components/__new/common/Maybe';
import WideViewModal from 'components/__new/common/WideViewModal';
import { useDispatch, useSelector } from 'react-redux';
import SingleAirtimePurchase from './SingleAirtimePurchase';
import MultipleAirtimePurchase from './MultipleAirtimePurchase';
import AirtimePurchasePreview from './AirtimePurchasePreview';
import { clearAirtimePreviewItems, saveAirtimePreviewItems } from 'store/entities/billPayment/action';
import BulkAirtimePurchase from './BulkAirtimePurchase';


const AirtimePurchaseType = ({
    isOpen,
    togglePurchaseModal,
    toggleAirtimeReview,
    toggleAmountSetup, 
    setPreviewItems,
    airtimeTabItems,
    setAirtimePurchaseType,
    initiatePurchase,
    previewItems,
    defaultParams,
    generateClientReference,
    selectSingleBeneficiary,
    setSelectSingleBeneficiary
}) => {
    const dispatch = useDispatch();
    const { InlineRouterTab, activeTab } = useInlinePageRouter("single");
    const [isWideViewOpen, setIsWideViewOpen] = useState(false);
    const {airtimePreviewItems} = useSelector((state) => state.entities.billPayment)
    
    const isMultipleTransfer = activeTab === "multiple";
    const isBulkTransfer = activeTab === "bulk";
    
    const closeModal = () => {
        setPreviewItems([]);
        dispatch(clearAirtimePreviewItems());
        togglePurchaseModal();
    }
    
    const proceedToAmountSetup = () => {
        dispatch(saveAirtimePreviewItems(previewItems));
        togglePurchaseModal();
        toggleAmountSetup();
    }
    
    useEffect(() => {
        if(activeTab !== "multiple" && isWideViewOpen === true) {
            setIsWideViewOpen(false);
        }
        setPreviewItems([])
        // eslint-disable-next-line
    }, [activeTab])
    
    
    useEffect(() => {
        if((isMultipleTransfer && airtimePreviewItems?.length > 0) && (isWideViewOpen === false)) {
            setPreviewItems(airtimePreviewItems);
            setIsWideViewOpen(true);
        }
        // eslint-disable-next-line
    }, [airtimePreviewItems, isWideViewOpen])
    
    return (
        <WideViewModal wideViewControl={isWideViewOpen} size={"md"} wideViewClassName="w-[60%]" dialogPanelClassName="h-max-full" isOpen={isOpen} setIsOpen={() => {}}>
            <div className={`relative ${isWideViewOpen && "flex items-start justify-between"}`}>
                <div className={`${isWideViewOpen ? "w-2/5" : "w-full"} bill-payments-purchase`}>
                    
                    <div className='pb-2 mb-4 border-b border-gray-200'>
                        <div className="flex items-center justify-between">
                            <div className="text-xl font-bold">
                                Purchase Airtime
                            </div>
                            
                            <Maybe condition={isWideViewOpen === false}>
                                <div onClick={closeModal} className='w-7 h-7 bg-[#f4f4f4] cursor-pointer rounded-md flex items-center justify-center'>
                                    <IconTimes width={30} />
                                </div>
                            </Maybe>
                        </div>
                        
                        <div className="pt-2 text-gray-600">
                            Purchase airtime for {isMultipleTransfer ? "2 - 20 recipients" : isBulkTransfer ? "multiple recipients at once" : "one recipient"}
                        </div>
                    </div>
                    
                    <InlineRouterTab
                        tabMode
                        useFullWidth
                        items={airtimeTabItems}
                        onTabChange={(activeItem) => setAirtimePurchaseType(activeItem)}
                    />
                    
                    <div className="pt-4">
                        <Maybe condition={activeTab === "single"}>
                            <SingleAirtimePurchase 
                                initiatePurchase={initiatePurchase}
                                togglePurchaseModal={togglePurchaseModal}
                                defaultParams={defaultParams}
                                generateClientReference={generateClientReference}
                                selectSingleBeneficiary={selectSingleBeneficiary}
                                setSelectSingleBeneficiary={setSelectSingleBeneficiary}
                            />
                        </Maybe>
                        
                        <Maybe condition={activeTab === "multiple"}>
                            <MultipleAirtimePurchase 
                                previewItems={previewItems}
                                setPreviewItems={setPreviewItems}
                                togglePurchaseModal={togglePurchaseModal}
                                isWideViewOpen={isWideViewOpen}
                                setIsWideViewOpen={setIsWideViewOpen}
                                defaultParams={defaultParams}
                                generateClientReference={generateClientReference}
                            />
                        </Maybe>
                        
                        <Maybe condition={activeTab === "bulk"}>
                            <BulkAirtimePurchase 
                                togglePurchaseModal={togglePurchaseModal}
                                toggleAirtimeReview={toggleAirtimeReview}
                            />
                        </Maybe>
                    </div>
                </div>
                
                <Maybe condition={isWideViewOpen}>
                    <div className='w-3/5 ml-5'>
                        <AirtimePurchasePreview 
                            isOpen={isWideViewOpen}
                            previewItems={previewItems}
                            setPreviewItems={setPreviewItems}
                            setIsOpen={setIsWideViewOpen}
                        />
                        <div className="rounded-3xl py-1.5 px-3 flex items-center justify-between bg-ep-primary-light-100">
                            <p className="text-ep-gray-500">Recipients</p>
                            <p className="text-ep-gray-600">{previewItems?.length}</p>
                        </div>
                    </div>
                </Maybe>
            </div>
            
            <Maybe condition={isWideViewOpen === true}>
                <div className="w-full flex items-center justify-end border-t pt-5 mt-5">
                    <button type="button" onClick={closeModal} className="btn btn-transparent-primary mr-3">
                        Cancel
                    </button>
                    
                    <button onClick={proceedToAmountSetup} className="btn btn-ep-primary">
                        Continue
                    </button>
                </div>
            </Maybe>
        </WideViewModal>
    )
}

export default AirtimePurchaseType